import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { isNil, isUndefined } from 'lodash'
import SelectField from '../../common/SelectField'

export class CensusesSelectFieldComponent extends Component {
  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.object
    ]),
    getInProgress: PropTypes.bool,
    handleChange: PropTypes.func.isRequired,
    displayNewCensus: PropTypes.bool,
    censuses: PropTypes.array,
    className: PropTypes.string
  }

  handleChange = (name, value) => {
    this.props.handleChange(name, value)
  }

  censusOptions(censuses) {
    if (!censuses) {
      return []
    }

    const censusOptions = censuses.map((census) => ({
      text: census.name,
      value: census.id
    }))

    let formattedOptions = [...censusOptions]

    if (this.props.displayNewCensus) {
      const createOption = {
        text: 'New Census',
        value: 'NewCensus'
      }

      formattedOptions = [createOption, ...censusOptions]
    }

    return formattedOptions
  }

  render() {
    const { censuses, className } = this.props
    let value = this.props.value

    const censusOptions = this.censusOptions(censuses)
    const disabled = isNil(censuses)

    if (!disabled && this.props.value !== 'NewCensus') {
      const census = censuses.find((record) => record.id.toString() === this.props.value)
      value = isUndefined(census) ? this.props.value : { value: this.props.value, label: census.name }
    }

    return (
      <div className={className || 'census-selection pure-form'}>
        <SelectField
          key="census_id"
          name="census_id"
          label="Censuses"
          handleChange={this.handleChange}
          value={value}
          isLoading={this.props.getInProgress}
          options={censusOptions}
          disabled={disabled}
        />
      </div>
    )
  }
}

export default CensusesSelectFieldComponent
